import { _buildLinePath } from '../../components/Canvas/CanvasLine';
import { parseDocument } from './parser';
import { nanoid } from 'nanoid';

function baseToText(base) {
    // try {
    if (typeof base !== 'string') {
        throw new TypeError('Input must be a Base64-encoded string.');
    }

    const binaryString = atob(base);
    const byteArray = Uint8Array.from(binaryString, char => char.charCodeAt(0));
    const decoded = new TextDecoder().decode(byteArray);

    return decoded;
    // } catch (error) {
    // console.error('Failed to decode Base64:', error.message);
    // return null;
    // }
}

function getElements(parsedObj) {
    let diagramDetails = {};
    let elements = {};
    let lines = {};
    let areas = {};

    let tablesNamesIdsMap = {};
    let columnsNamesIdsMap = {};


    if (parsedObj.globalsMap) {
        let map = parsedObj.globalsMap;

        const scale = Number(map.scale);
        const origin = map.origin?.split(" ");
        const originX = Number(origin[0]);
        const originY = Number(origin[1]);

        diagramDetails = {
            title: map.title,
            description: map.description,
            db_engine: map.db_engine,
            scale,
            originXY: { x: originX, y: originY },
        }
    }

    parsedObj.tables.forEach(table => {
        const newTableId = nanoid();

        const xy = table?.attributes?.xy?.split(" ") || 0;
        const x = Number(xy[0]);
        const y = Number(xy[1]);

        const wh = table?.attributes?.wh?.split(" ") || 0;
        const w = Number(wh[0]);
        const h = Number(wh[1]);

        let elementData = {
            id: newTableId,
            type: "table",
            x: x,
            y: y,
            width: w,
            height: h,
            translateX: 0,
            translateY: 0,
            value: {
                header: { name: table.name },
                columns: {},
                border: table?.attributes?.border,
                color: table?.attributes?.color,
                description: table?.attributes?.note,
            },
        };

        let isTableWithIndexes = false;

        table.columns.forEach((column, index) => {
            const newColumnId = nanoid();

            if (column?.attributes?.index) {
                isTableWithIndexes = true;
            }

            elementData.value.columns[newColumnId] = {
                id: newColumnId,
                name: column.name,
                type: column.type,
                indexNumber: index,

                ...(!!column?.flags?.pk && { isPK: true }),
                ...(!!column?.flags?.fk && { isFK: true }),
                ...(!!column?.flags?.not_null && { isNN: true }),
                ...(!!column?.flags?.increment && { isAutoIncrement: true }),

                ...(column?.attributes?.check && { checkValue: column?.attributes?.check }),
                ...(column?.attributes?.generated_value && { generatedValue: column?.attributes?.generated_value }),
                ...(column?.attributes?.enum && { enumValues: column?.attributes?.enum.split(','), isEnum: true }),
                ...(column?.attributes?.index && { index: { type: column?.attributes?.index } }),
                ...(column?.attributes?.default && { defaultValue: column?.attributes?.default }),
                ...(column?.attributes?.note && { description: column?.attributes?.note }),

                // col.fkRefTable
                // col.fkRefColumn

            };

            const columnKey = `${newTableId}_${column.name}`;
            columnsNamesIdsMap[columnKey] = newColumnId;
        });

        if (isTableWithIndexes) {
            elementData.value.isTableWithIndexes = true;
        }
        elements[newTableId] = elementData;
        tablesNamesIdsMap[table.name] = newTableId;
    });

    // parsedObj.pens.forEach(pen => {
    //     const newPenId = nanoid();

    //     const xy = pen?.attributes?.xy?.split(" ") || 0;
    //     const x = Number(xy[0]);
    //     const y = Number(xy[1]);

    //     const wh = pen?.attributes?.wh?.split(" ") || 0;
    //     const w = Number(wh[0]);
    //     const h = Number(wh[1]);

    //     const txy = pen?.attributes?.txy?.split(" ") || 0;
    //     const tx = Number(txy[0]);
    //     const ty = Number(txy[1]);

    //     const oxy = pen?.attributes?.oxy?.split(" ") || 0;
    //     const ox = Number(oxy[0]);
    //     const oy = Number(oxy[1]);

    //     let elementData = {
    //         id: newPenId,
    //         type: "pen-segment",
    //         x: x,
    //         y: y,
    //         width: w,
    //         height: h,
    //         translateX: tx,
    //         translateY: ty,
    //         value: {
    //             origin: { x: ox, y: oy },
    //             scale: pen?.attributes?.scale || 1,
    //             path: pen?.attributes?.path || "",
    //         },
    //     };

    //     elements[newPenId] = elementData;
    // });

    parsedObj.lines.forEach(line => {
        const newLineId = nanoid();

        const fromTableName = line.from.table;
        const fromColumnName = line.from.columns[0];

        const toTableName = line.to.table;
        const toColumnName = line.to.columns[0];

        const fromElementId = tablesNamesIdsMap[fromTableName];
        const toElementId = tablesNamesIdsMap[toTableName];

        if (!fromElementId || !toElementId) {
            return;
        }

        const fromColumnKey = `${fromElementId}_${fromColumnName}`;
        const toColumnKey = `${toElementId}_${toColumnName}`;

        const fromInsideElementId = columnsNamesIdsMap[fromColumnKey];
        const toInsideElementId = columnsNamesIdsMap[toColumnKey];

        if (!fromInsideElementId || !toInsideElementId) {
            return;
        }

        const fromElement = elements[fromElementId];
        const toElement = elements[toElementId];


        if (!fromElement || !toElement) {
            return;
        }

        const fromInsideElement = fromElement.value.columns[fromInsideElementId];
        const toInsideElement = toElement.value.columns[toInsideElementId];

        if (!fromInsideElement || !toInsideElement) {
            return;
        }

        const lineBuildData = {
            mouseX: null,
            mouseY: null,

            fromElementType: 'table',
            fromElementWidth: fromElement?.width || 0,
            fromElementX: fromElement?.x || 0,
            fromElementY: fromElement?.y || 0,
            fromInsideElementIndex: fromInsideElement.indexNumber,
            fromRelationType: line.attributes.from_type,

            toElementType: 'table',
            toElementWidth: toElement?.width || 0,
            toElementX: toElement?.x || 0,
            toElementY: toElement?.y || 0,
            toInsideElementIndex: toInsideElement.indexNumber,
            toRelationType: line.attributes.to_type,
        };

        const path = _buildLinePath(lineBuildData);

        let lineData = {
            id: newLineId,
            type: "line",

            value: {
                fromElementId,
                fromInsideElementId,
                fromRelationType: line.attributes.from_type,

                toElementId,
                toInsideElementId,
                toRelationType: line.attributes.to_type,

                fromElementX: fromElement?.x || 0,
                fromElementY: fromElement?.y || 0,
                toElementX: toElement?.x || 0,
                toElementY: toElement?.y || 0,
                path,

                onDeleteTrigger: line.attributes.on_delete,
                onUpdateTrigger: line.attributes.on_update,

                solidType: line.attributes.solid_type,
                color: line.attributes.color,
                description: line.attributes.note,
            },
        };

        lines[newLineId] = lineData;
    });

    parsedObj.areas.forEach(area => {
        const newAreaId = nanoid();

        const xy = area?.attributes?.xy?.split(" ") || 0;
        const x = Number(xy[0]);
        const y = Number(xy[1]);

        const wh = area?.attributes?.wh?.split(" ") || 0;
        const w = Number(wh[0]);
        const h = Number(wh[1]);

        let areaData = {
            id: newAreaId,
            type: "area",
            x: x,
            y: y,
            width: w,
            height: h,
            value: {
                border: area?.attributes?.border,
                color: area?.attributes?.color,
                description: area?.attributes?.note,
                nestedElementsIds: [],
            },
        };

        area.elements.forEach(elementName => {
            const elementId = tablesNamesIdsMap[elementName];
            if (elementId) {
                areaData.value.nestedElementsIds.push(elementId);
            }
        });

        areas[newAreaId] = areaData;
    });

    return [diagramDetails, elements, lines, areas];
}

function decode(base) {
    let result = null;
    let isError = false;

    try {
        const text = baseToText(base);
        const parsedObj = parseDocument(text);
        // console.log("CODE:\n", text, "\n\nPARSED:\n", parsedObj);

        const [diagramDetails, elements, lines, areas] = getElements(parsedObj);
        result = [diagramDetails, elements, lines, areas];
    } catch (err) {
        isError = true;
    }

    return [result, isError];
}

// function decodeDetails(base) {
//     let result = null;
//     let isError = false;

//     try {
//         const text = baseToText(base);
//         const obj = textToObject(text);
//         result = obj;
//     } catch (err) {
//         isError = true;
//     }

//     return [result, isError];
// }

export { decode };
